<template>
	<Form ref="formValidate" :model="formValidate" :label-width="110" :label-colon="true">
		<Row>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="状态" :label-width="80">
				<Select v-model="formValidate.status" clearable  style="width:200px">
					<Option :value="0" key="0">下线</Option>
					<Option :value="1" key="1">上线</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="数据来源"   :label-width="80">
				<Select v-model="formValidate.dataFrom" clearable style="width:200px">
					<Option :value="2" key="2">自营</Option>
					<Option :value="1" key="3">青团</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="工作场景"   :label-width="80">
				<Select v-model="formValidate.scene" clearable style="width:200px">
					<Option :value="2" key="2">线下</Option>
					<Option :value="1" key="1">线上</Option>
				</Select>
			</FormItem>
			</Col>
			
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="青团岗位ID" :label-width="100">
				<Input v-model="formValidate.partTimeId" clearable />
			</FormItem>
			</Col>
			
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="公司名称" :label-width="80">
				<Input v-model="formValidate.company" clearable />
			</FormItem>
			</Col>
			
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="岗位名称" :label-width="80">
				<Input v-model="formValidate.title" clearable />
			</FormItem>
			</Col>
			
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="岗位类目" :label-width="80">
				<Input v-model="formValidate.secondTagName" clearable />
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="城市" :label-width="80">
				<Input v-model="formValidate.city" clearable />
			</FormItem>
			</Col>
			<Col :md="12" :sm="12" :xs="24">
			<FormItem>
				<Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 0px;">查询</Button>
				<Button type="default" @click="formReset" style="margin: 0 8px 16px 16px;">重置</Button>
			</FormItem>
			</Col>
		</Row>
	</Form>

</template>
<script>
	import api from '../../api'
	import {
		mapGetters
	} from 'vuex'
	import {
		STATISTICS_START_TIME,
		LINK_TYPES
	} from '../../config/constants'

	export default {
		name: 'QueryCondition',
		props: {

		},
		data() {
			return {
				apps: [],
				events: [],
				appId: '',
				advertType: 'table',
				formValidate: {
					status: '1',
					scene: undefined,
					company: '',
					partTimeId: '',
					title: '',
					secondTagName: '',
					dataFrom:undefined,
					city:undefined
				}
			}
		},
		computed: {
			...mapGetters('statistics', ['accountGroup', 'pageStatus'])
		},
		mounted() {

		},
		methods: {
			formSubmit() {
				this.$emit('query', this.getFormData())
			},
			formReset() {
				this.$refs['formValidate'].resetFields()
				this.formValidate = {}
				//this.formSubmit()
			},
			getFormData() {
				const formData = {
					scene: this.formValidate.scene,
					title: this.formValidate.title,
					secondTagName: this.formValidate.secondTagName,
					status: this.formValidate.status,
					partTimeId: this.formValidate.partTimeId,
					company: this.formValidate.company,
					dataFrom:this.formValidate.dataFrom,
					city:this.formValidate.city
				}
				return formData
			},

		}
	}
</script>